import Andornment from './InputGroupAndornment';
import Avatar from './InputGroupAvatar';
import Input from './InputGroupInput';
import Root from './InputGroupRoot';
import Textarea from './InputGroupTextarea';

export const InputGroup = {
  Root,
  Andornment,
  Textarea,
  Input,
  Avatar,
};
